<div
  class="tile-groups"
  cdkDropList
  [cdkDropListData]="tileGroups"
  (cdkDropListDropped)="dropTileGroup($event)"
>
  <h2>
    <div
      class="title"
    >
      Tile Groups
      <button
        class="small green"
        (click)="addGroup()"
      >
        Add Group
      </button>

      @if (tileGroups) {
        <button
          class="small white violet"
          [class.loading]="bulkEditIsLoading"
          (click)="openBulkEdit()"
        >
          <span>Bulk Edit</span>
          <motn-spinner></motn-spinner>
        </button>
      }
    </div>

    <div class="label">
      <span>
        Drag and drop tile groups using the
        <i class="fa-solid fa-grip-dots-vertical"></i>
        symbol to re-order
      </span>
    </div>
  </h2>

  @if (!tileGroups) {
    <motn-spinner></motn-spinner>
  }

  @if (tileGroups) {
    @for (tileGroup of tileGroups; track $index) {
      <div
        cdkDrag
        class="tile-group"
        [cdkDragDisabled]="!$index"
      >
        @if (tileGroup.Ungrouped) {
          <h3
            (click)="showUngroupedInfo()"
            class="ungrouped"
          >
            Ungrouped Tiles
            <i class="far fa-info-circle"></i>
          </h3>
        }

        @if (!tileGroup.Ungrouped) {
          <h3>
            <div
              class="group-grip"
              cdkDragHandle
            >
              <i class="fa-solid fa-grip-dots-vertical"></i>
            </div>

            <input
              [(ngModel)]="tileGroup.Name"
              (ngModelChange)="updateStatus()"
            >

            <button
              class="small red"
              (click)="deleteGroup($index)"
            >
              <i class="fa-solid fa-xmark"></i> Group
            </button>
          </h3>
        }

        <div>
          <motn-tile-order-sorter
            #tileOrderSorterComponent
            [listIdForCdk]="getTileListId($index)"
            [connectedListIdsForCdk]="getConnectedTileListIds($index)"
            [tiles]="selectableTiles"
            [tileOrder]="tileGroup.Tiles"
            [selectableTilesOptionGroup]="selectableTilesOptionGroups[$index]"
            (clickedX$)="removeTile($index, $event).subscribe()"
            (draggedAndDropped$)="dropTile($event)"
            (sortedById$)="sortGroupById($index, $event)"
          ></motn-tile-order-sorter>
        </div>
      </div>
    }

    <div
      class="buttons"
    >
      <motn-save-revert-buttons
        [status]="status"
        [small]="false"
        (clickedSave$)="save()"
        (clickedRevert$)="revert()"
        (updatedStatus$)="status = $event"
      ></motn-save-revert-buttons>
    </div>
  }
</div>

@if (bulkEditIsOpen) {
  <motn-app-bulk-editor
    [tiles]="editableTiles"
    (closed$)="onBulkEditorClose()"
  ></motn-app-bulk-editor>
}
